import { Route, Switch, Redirect } from 'react-router-dom';

import { routes } from '~/constants';

import { CreatePassword } from './CreatePassword';

export const CreatePasswordRoutes = () => (
  <Switch>
    <Route exact path={`${routes.create_password}/:token`} component={CreatePassword} />

    <Redirect from="*" to="/" />
  </Switch>
);
